/**
 * App Component
 * Main application with routing and layout
 */

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Layout components
import Header from './components/Layout/Header';
import Footer from './components/Layout/Footer';

// Page components
import Home from './pages/Home';
import Pricing from './pages/Pricing';
import HowItWorks from './pages/HowItWorks';
import WhyTaaS from './pages/WhyTaaS';
import About from './pages/About';
import Contact from './pages/Contact';
import TaasOverviewPage from './pages/TaasOverviewPage';

// Global styles
import './styles/global.css';

/**
 * Main App component
 * Sets up routing and common layout (Header/Footer)
 */
function App() {
  return (
    <Router>
      <div className="app">
        {/* Site Header with Navigation */}
        <Header />

        {/* Page Routes */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/what-is-taas" element={<TaasOverviewPage />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/why-taas" element={<WhyTaaS />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />

          {/* Fallback route - redirect to home */}
          <Route path="*" element={<Home />} />
        </Routes>

        {/* Site Footer */}
        <Footer />
      </div>
    </Router>
  );
}

export default App;
